import * as React from 'react'
import { render } from 'react-dom'

import 'whatwg-fetch'

import {
	Form,
	FormGroup,
	FormControl,
	ControlLabel,
	Row,
	Col,
	Button,
	HelpBlock,
	Glyphicon,
	InputGroup,
} from 'react-bootstrap'

import { equals } from 'class-validator'

interface Props extends React.Props<ResetPasswordContainer> {}

interface State {
	sendBtnStatus: boolean
	error: boolean
	validationState1: 'success' | 'error' | undefined
	validationState2: 'success' | 'error' | undefined
	validationMsg1?: string
	validationMsg2?: string
	username?: string
	password?: string
	passwordConfirm?: string
	token?: string
	confirmationTimer: number | undefined
	[key: string]: string | boolean | undefined | number
}
class ResetPasswordContainer extends React.Component<Props, State> {
	constructor(props: {}) {
		super(props)
		this.state = {
			sendBtnStatus: false,
			username: '',
			password: '',
			passwordConfirm: '',
			token: '',
			error: false,
			validationState1: undefined,
			validationState2: undefined,
			validationMsg1: '',
			validationMsg2: '',
			confirmationTimer: undefined,
		}
	}

	public componentDidMount() {
		const el = document.getElementById('root')
		if (el) {
			//console.log(el.dataset.user)
			this.setState({ username: el.dataset.user, token: el.dataset.token })
		}
	}

	public formPreventDefault = (e: React.FormEvent<HTMLInputElement>): void => {
		e.preventDefault()
	}

	public processString(
		str: string,
	): { status: boolean; validationStatus: 'success' | 'error' | undefined; validationMsg?: string } {
		const containsLetters = /[a-zA-Z]/
		const containsNumber = /[0-9]/

		if (str.length < 8) {
			return {
				status: false,
				validationStatus: 'error',
				validationMsg: 'Your password should be at least 8 characters long.',
			}
		}
		if (containsLetters.test(str) === false) {
			return {
				status: false,
				validationStatus: 'error',
				validationMsg: 'Your password should contain letters and numbers.',
			}
		}
		if (containsNumber.test(str) === false) {
			return {
				status: false,
				validationStatus: 'error',
				validationMsg: 'Your password should contain at least one number.',
			}
		}
		return {
			status: true,
			validationStatus: 'success',
			validationMsg: '', // 'Password appears to be valid.',
		}
	}
	public checkPasswd = (key: string): void => {
		const passwd = this.state.password || ''
		const passwdConfirm = this.state.passwordConfirm || ''
		const result = this.processString(passwd)
		if (key === 'password') {
			if (!result.status) {
				this.setState({
					validationState1: result.validationStatus,
					validationMsg1: result.validationMsg,
				})
			} else {
				let validationState2: 'success' | 'error' | undefined
				let validationMsg2: string = ''
				if (passwdConfirm.length > 0 && !equals(passwd, passwdConfirm)) {
					validationState2 = 'error'
					validationMsg2 = 'Password does not match the confirm password'
				}
				this.setState({
					validationState1: result.validationStatus,
					validationMsg1: result.validationMsg,
					validationState2,
					validationMsg2,
				})
			}
		}
		if (key === 'passwordConfirm') {
			if (!equals(passwd, passwdConfirm)) {
				this.setState({
					validationState2: 'error',
					validationMsg2: 'Password does not match the confirm password',
				})
			}
			if (passwdConfirm && passwdConfirm.length >= 8 && equals(passwd, passwdConfirm)) {
				this.setState({
					validationState2: 'success',
					validationMsg2: '', // 'Password confirmation is correct',
				})
			}
		}
	}

	public setValue = (key: string, event: React.FormEvent<HTMLSelectElement>): void => {
		const val = event.currentTarget.value
		this.setState(() => {
			let validationState2: 'success' | 'error' | undefined
			let validationMsg2: string = ''
			if (key === 'password') {
				if (this.state.passwordConfirm && this.state.password !== this.state.passwordConfirm) {
					validationState2 = 'error'
					validationMsg2 = 'Password does not match the confirm password'
				}
			}
			return {
				[key]: val,
				validationState2,
				validationMsg2,
			}
		})
	}

	public resetPassword = async () => {
		const passwd = this.state.password || ''
		const passwdConfirm = this.state.passwordConfirm || ''
		const result = this.processString(passwd)
		if (result.status && equals(passwd, passwdConfirm)) {
			this.setState({ sendBtnStatus: true })
			//console.log("sending...", JSON.stringify(this.state))
			const headers = new Headers()
			headers.append('Accept', 'application/json')
			headers.append('Content-Type', 'application/json')
			const res = await fetch('/users/resetPassword', {
				method: 'POST',
				credentials: 'same-origin',
				headers,
				body: JSON.stringify(this.state),
			})
			const data = await res.json()
			this.setState(
				{
					validationState2: 'success',
					validationMsg2:
						'Your password have been updated successfully. You will be directed to the login page shortly!',
				},
				() => {
					setTimeout(() => (window.location.href = '/users/login'), 5000)
				},
			)
		}
	}

	public render() {
		return (
			<div>
				<Row>&nbsp;</Row>
				<Row>&nbsp;</Row>

				<h4>Enter a new password</h4>

				<Row>&nbsp;</Row>

				<Form onSubmit={(e) => this.formPreventDefault(e as any)}>
					<FormGroup validationState={this.state.validationState1}>
						<ControlLabel>Password</ControlLabel>
						<FormControl
							type="password"
							value={this.state.password}
							onChange={(e) => this.setValue('password', e as any)}
							onBlur={() => this.checkPasswd('password')}
						/>
						<HelpBlock>
							<strong>{this.state.validationMsg1}</strong>
						</HelpBlock>
					</FormGroup>
					<FormGroup validationState={this.state.validationState2}>
						<ControlLabel>Password confirmation</ControlLabel>
						<FormControl
							type="password"
							value={this.state.passwordConfirm}
							onChange={this.setConfirmationPassword}
							onBlur={() => this.checkPasswd('passwordConfirm')}
						/>
						<HelpBlock>
							<strong>{this.state.validationMsg2}</strong>
						</HelpBlock>
					</FormGroup>
					<Button
						bsStyle="primary"
						onClick={() => this.resetPassword()}
						block
						disabled={
							this.state.validationState1 !== 'success' || this.state.validationState2 !== 'success'
						}
					>
						Reset Password
					</Button>
				</Form>

				<Row>&nbsp;</Row>
				<Row>&nbsp;</Row>
			</div>
		)
	}

	private setConfirmationPassword = (event: React.FormEvent<any>) => {
		this.setValue('passwordConfirm', event)
		if (this.state.confirmationTimer) {
			window.clearTimeout(this.state.confirmationTimer)
		}
		this.setState({
			confirmationTimer: window.setTimeout(() => {
				this.checkPasswd('passwordConfirm')
				this.setState({ confirmationTimer: undefined })
			}, 600),
		})
	}
}
export default ResetPasswordContainer as React.ComponentClass<Props>
